import React, { MouseEvent } from 'react';
import { observer } from 'mobx-react';
import { Table } from 'antd';
import { Catcher, TableItemToolbar, columnToolbar } from '../../';
import { IZoneTable } from '../../../interfaces';
import { useRouterStore, useUiIsLoading, useUiSearch, useZonesTable } from '../../../hooks';
import { deleteZone } from '../../../middleware';
import { lightText } from '../../../instruments';
import { tF, tI } from '../../../translate';
import StylesLink from '../../LinkComponent/m_styles.less';
import Styles from '../../styles/m_viewStyles.less';

export const ZonesTableList: React.FC = observer(() => {
    const isLoading = useUiIsLoading();
    const zonesList = useZonesTable();
    const routerStore = useRouterStore();
    const search = useUiSearch();

    const tableColumns = [
        {
            title: tF('Name'),
            dataIndex: 'name',
        },
        {
            title: tF('Countries'),
            dataIndex: 'countryCount',
        },
        columnToolbar,
    ];
    const tableData = zonesList.map((z: IZoneTable) => {
        const deleteItem = (): void => {
            deleteZone(z.id);
        };
        const name = z.name ? z.name : `# ${z.id}`;
        const goToCountries = (event: MouseEvent<HTMLAnchorElement>): void => {
            if (!(event.ctrlKey || event.metaKey || event.altKey || event.shiftKey)) {
                event.preventDefault();
                routerStore.goTo('CountryList', { queryParams: { zoneId: z.id } });
            }
        };

        return {
            key: z.id,
            ...z,
            name: <span>{lightText(name, search)}</span>,
            countryCount: (
                <a className={StylesLink.linkItem} href={`/countries?zoneId=${z.id}`} onClick={goToCountries}>
                    {z.countryCount}
                </a>
            ),
            toolbar: (
                <TableItemToolbar
                    itemName={`"${name}" ${tI('zone')}`}
                    id={z.id}
                    deleteItem={deleteItem}
                    isView={false}
                />
            ),
        };
    });

    return (
        <Catcher>
            <div className={Styles.tablePlace}>
                <Table
                    className={'table-theme'}
                    columns={tableColumns}
                    dataSource={tableData}
                    loading={isLoading}
                    pagination={false}
                    size={'middle'}
                />
            </div>
        </Catcher>
    );
});
